var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoRwSmall = function SvgLogoRwSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2185_9563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 16,
    width: 9,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4542 16.8008H50.4158V36.2293H42.4542V16.8008Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2185_9563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0943 26.7395C44.0943 24.3055 43.5323 21.9976 42.5279 19.9307C42.3513 19.5689 42.5022 19.1368 42.8728 18.9573L47.1672 16.8788C47.548 16.6947 48.0125 16.8477 48.1955 17.2201C49.6184 20.1041 50.4159 23.332 50.4159 26.7395C50.4159 29.9675 49.6994 33.0328 48.4145 35.7967C48.2305 36.194 47.7301 36.3478 47.3402 36.13L43.1552 33.7955C42.825 33.6106 42.6889 33.2177 42.8351 32.8763C43.6454 30.9863 44.0943 28.9131 44.0943 26.7395Z",
    fill: "#227D3E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2185_9563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 4,
    width: 18,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6243 4.58334H46.46V16.8949H29.6243V4.58334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2185_9563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6243 10.0031V5.31988C29.6243 4.87983 30.0216 4.53668 30.4732 4.58824C36.9861 5.33855 42.6593 8.72741 46.3172 13.6178C46.5913 13.9849 46.4561 14.5023 46.0385 14.7041L41.6733 16.8173C41.3513 16.9729 40.9623 16.8884 40.7379 16.6164C38.1956 13.5209 34.4954 11.3544 30.2699 10.7277C29.8984 10.6734 29.6243 10.3658 29.6243 10.0031Z",
    fill: "#2881BE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9049 26.7396C10.9049 29.0368 11.4053 31.221 12.3048 33.1964C12.4621 33.5404 12.3287 33.944 11.9921 34.1307L7.81355 36.4635C7.42816 36.6786 6.93333 36.5301 6.74385 36.1399C5.35776 33.2862 4.58331 30.1009 4.58331 26.7396C4.58331 23.4272 5.33661 20.2846 6.68499 17.4629C6.87262 17.0709 7.3693 16.9206 7.75652 17.1366L11.9369 19.4694C12.2717 19.6561 12.405 20.0552 12.2524 20.3993C11.385 22.3444 10.9049 24.4878 10.9049 26.7396Z",
    fill: "#227D3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8158 36.0993L45.9925 38.4303C46.3788 38.6463 46.4938 39.137 46.2363 39.4891C44.887 41.3373 43.5275 42.685 41.6705 44.0568L44.8842 50.4167L36.2586 47.2109C34.2121 48.0297 32.0184 48.5702 29.7245 48.7854C29.2794 48.8262 28.894 48.4849 28.894 48.051V43.3838C28.894 43.0122 29.1819 42.7019 29.5627 42.6557C34.1679 42.1036 38.1864 39.7291 40.8234 36.3011C41.0552 36.0007 41.4801 35.9126 41.8158 36.0993Z",
    fill: "#F5A61D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3295 17.1957L9.1455 14.8603C8.75552 14.6425 8.64331 14.1456 8.90636 13.7935C12.7344 8.66757 18.7737 5.18803 25.6738 4.66174C26.1144 4.62885 26.4905 4.96934 26.4905 5.39695V10.0562C26.4905 10.434 26.1935 10.7478 25.8044 10.7861C21.1274 11.2448 17.0243 13.5811 14.3146 17.0028C14.0819 17.2971 13.6616 17.3806 13.3295 17.1957Z",
    fill: "#DB1F26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.16 43.391V48.0574C26.16 48.4885 25.7765 48.8308 25.3331 48.7908C18.5296 48.1738 12.5915 44.6827 8.83152 39.5861C8.5703 39.2332 8.68436 38.7398 9.0725 38.5229L13.2538 36.1892C13.5877 36.0025 14.0107 36.0897 14.2425 36.3866C16.8906 39.7808 20.9008 42.126 25.4886 42.6629C25.8712 42.7065 26.16 43.0185 26.16 43.391Z",
    fill: "#2881BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8718 22.7078H34.5659C34.381 22.7078 34.2219 22.8323 34.1833 23.0065L33.0593 28.1761L31.9639 23.0083C31.9252 22.8341 31.7652 22.7078 31.5803 22.7078H29.2947C29.108 22.7078 28.947 22.8358 28.9102 23.0119L27.8819 28.12L26.7662 23.0065C26.7276 22.8323 26.5685 22.7078 26.3845 22.7078L23.1515 22.6527C22.3642 22.6527 21.7093 22.8581 21.209 23.2635C21.0572 23.3835 20.8963 23.5479 20.7252 23.7613V23.155C20.7252 22.9941 20.5909 22.8643 20.4244 22.8643H18.1351C17.9696 22.8643 17.8344 22.9941 17.8344 23.155V31.9392C17.8344 32.1534 18.0146 32.3277 18.2372 32.3277H20.4493C20.6718 32.3277 20.8521 32.1534 20.8521 31.9392V27.792C20.8521 27.1306 20.934 26.6425 21.0959 26.3447C21.3745 25.8335 21.9255 25.5846 22.7809 25.5846C22.8508 25.5846 22.9418 25.5873 23.054 25.5926C23.1589 25.5971 24.0474 25.6069 24.2847 25.6202L26.1509 32.0441C26.1997 32.2121 26.3579 32.3277 26.5391 32.3277H28.8725C29.0611 32.3277 29.2257 32.2006 29.2653 32.0219L30.4141 26.927L31.5491 32.021C31.5895 32.2006 31.7532 32.3277 31.9427 32.3277H34.2513C34.4307 32.3277 34.5889 32.213 34.6386 32.0476L37.2479 23.1923C37.3206 22.9496 37.133 22.7078 36.8718 22.7078Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoRwSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo-rw-small.3b03ffd02658bf848d5a2f88bb470002.svg";